import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const LegalPageLayout = ({ title, children }) => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-[100dvh] bg-[#F5F0EB]"
      data-testid="legal-page"
    >
      {/* Header */}
      <div className="sticky top-0 z-10 bg-[#F5F0EB]/95 backdrop-blur-sm border-b border-[#1A1A1A]/[0.06]">
        <div className="flex items-center gap-3 pt-12 pb-4 px-4">
          <button
            onClick={() => navigate("/")}
            className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A1A1A]/5 active:bg-[#1A1A1A]/10 transition-colors flex-shrink-0"
            data-testid="legal-back-button"
          >
            <ChevronLeft size={20} className="text-[#1A1A1A]/70" strokeWidth={2} />
          </button>
          <h1
            className="font-serif text-[18px] sm:text-[20px] text-[#1A1A1A] font-medium tracking-tight leading-snug"
            data-testid="legal-page-title"
          >
            {title}
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="px-5 pt-6 pb-16 max-w-[640px] mx-auto" data-testid="legal-page-content">
        {children}
      </div>
    </div>
  );
};

export default LegalPageLayout;
